import { render, staticRenderFns } from "./registeredrequests.vue?vue&type=template&id=cb6f467c&"
import script from "./registeredrequests.vue?vue&type=script&lang=js&"
export * from "./registeredrequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports